/* Hugsify product page features. No dependencies; uses Dawn's pubsub when present. */
(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  const range = (s) => s.split('-').map(Number);

  /* ---------- Delivery estimate ---------- */
  const addBusinessDays = (from, days) => {
    const d = new Date(from);
    while (days > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) days--;
    }
    return d;
  };
  const fmt = (d) => d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  const span = (a, b) => {
    if (fmt(a) === fmt(b)) return fmt(a);
    // Same month reads shorter and never wraps: "Oct 26–27"
    return a.getMonth() === b.getMonth() ? `${fmt(a)}–${b.getDate()}` : `${fmt(a)} – ${fmt(b)}`;
  };

  $$('[data-hs-delivery]').forEach((el) => {
    const [pMin, pMax] = range(el.dataset.processing);
    const [sMin, sMax] = range(el.dataset.shipping);
    const start = new Date();
    if (start.getHours() >= Number(el.dataset.cutoff || 24)) start.setDate(start.getDate() + 1);
    const ship = [addBusinessDays(start, pMin), addBusinessDays(start, pMax)];
    const arrive = [addBusinessDays(ship[0], sMin), addBusinessDays(ship[1], sMax)];
    $('[data-hs-eta]', el).textContent = span(...arrive);
    const set = (k, v) => { const n = $(`[data-hs-date="${k}"]`, el); if (n) n.textContent = v; };
    set('ordered', fmt(new Date()));
    set('ships', span(...ship));
    set('delivered', span(...arrive));
  });

  // Free-shipping line follows the cart drawer's bar, which Dawn re-renders after every cart change
  const freeShip = $('[data-hs-free-ship]');
  if (freeShip && window.subscribe && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () =>
      setTimeout(() => {
        const drawer = $('cart-drawer');
        if (!drawer) return;
        const bar = $('.hs-ship__text', drawer);
        freeShip.innerHTML = bar ? bar.innerHTML : freeShip.dataset.base;
      })
    );
  }

  /* ---------- Multi-buy tiles ---------- */
  const formatMoney = (cents, format) => {
    const n = (cents / 100).toFixed(2);
    const [i, f] = n.split('.');
    const withSep = (sep) => i.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) =>
      ({
        amount: `${withSep(',')}.${f}`,
        amount_no_decimals: withSep(','),
        amount_with_comma_separator: `${withSep('.')},${f}`,
        amount_no_decimals_with_comma_separator: withSep('.'),
      })[k] ?? n
    );
  };

  $$('[data-hs-multibuy]').forEach((el) => {
    const tiles = $$('.hs-tile', el);
    const select = (qty) =>
      tiles.forEach((t) => {
        const on = String(Number(t.dataset.qty) === qty);
        t.setAttribute('aria-pressed', on);
        t.setAttribute('aria-checked', on);
      });
    const reprice = (price) => {
      tiles.forEach((t) => {
        $('[data-hs-each]', t).textContent = formatMoney(Math.round((price * (100 - Number(t.dataset.pct))) / 100), el.dataset.moneyFormat);
        const was = $('[data-hs-was]', t);
        if (was) was.textContent = formatMoney(price, el.dataset.moneyFormat);
      });
    };
    // Dawn re-renders the quantity input on variant change, so always look it up fresh.
    const input = () => document.getElementById(`Quantity-${el.dataset.section}`);
    const setQty = (qty) => {
      const i = input();
      if (!i || Number(i.value) === qty) return;
      i.value = qty;
      i.dispatchEvent(new Event('change', { bubbles: true }));
    };
    let chosen = 1;
    tiles.forEach((t) =>
      t.addEventListener('click', () => {
        chosen = Number(t.dataset.qty);
        select(chosen);
        setQty(chosen);
      })
    );
    document.addEventListener('change', (e) => {
      if (e.target === input()) select((chosen = Number(e.target.value)));
    });
    if (window.subscribe && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data?.sectionId !== el.dataset.section || !data.variant) return;
        reprice(data.variant.price);
        setQty(chosen); // keep the shopper's chosen quantity across size/color changes
      });
      // Dawn resets the quantity to its minimum (no change event) after add to cart AND after
      // variant changes. After add to cart we follow the reset; otherwise we keep the choice.
      let justAdded = false;
      subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => {
        if (e?.source === 'product-form') justAdded = true;
      });
      subscribe(PUB_SUB_EVENTS.quantityUpdate, () => {
        const i = input();
        if (!i) return;
        if (justAdded) {
          justAdded = false;
          select((chosen = Number(i.value) || 1));
        } else setQty(chosen);
      });
    }
  });

  /* ---------- Opt-in add-ons (gift box, greeting card) ---------- */
  const addons = [...document.querySelectorAll('[data-hs-addon]')];
  if (addons.length && window.subscribe && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, async (event) => {
      const chosen = addons.filter((a) => $('.hs-addon__check', a).checked);
      if (event?.source !== 'product-form' || !chosen.length) return;
      const qty = Number($('input[name="quantity"]')?.value) || 1;
      const drawer = $('cart-drawer');
      try {
        const needCart = chosen.some((a) => a.dataset.mode === 'per_order');
        const cart = needCart ? await fetch(`${window.routes?.cart_url || '/cart'}.js`).then((r) => r.json()) : null;
        const items = chosen
          .map((a) => {
            const id = Number(a.dataset.variantId);
            const perOrder = a.dataset.mode === 'per_order';
            // one per order: skip when it is already in the cart
            if (perOrder && cart.items.some((i) => i.variant_id === id)) return null;
            return { id, quantity: perOrder ? 1 : qty, properties: { _for: $('.hs-addon__check', a).dataset.for } };
          })
          .filter(Boolean);
        if (!items.length) return;
        const res = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items,
            sections: drawer ? 'cart-drawer,cart-icon-bubble' : 'cart-icon-bubble,cart-notification-button',
            sections_url: window.location.pathname,
          }),
        }).then((r) => r.json());
        if (res.status) return; // add-on unavailable; the main item is already in the cart
        if (drawer) return drawer.renderContents(res);
        // Notification/page cart: refresh the cart count and "View cart (n)" button.
        for (const [id, html] of Object.entries(res.sections || {})) {
          const target = document.getElementById(id);
          const fresh = html && new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
          if (target && fresh) target.innerHTML = fresh.innerHTML;
        }
      } catch (e) {
        console.warn('[hugsify] add-on not added', e);
      }
    });
  }

  /* ---------- Gift message + spelling confirmation ----------
     Dawn's product form is novalidate, so `required` alone never blocks. This runs in the capture
     phase, before Dawn's submit handler: stop the add if the box is unticked, and leave an empty
     gift message out of the order. */
  document.addEventListener(
    'submit',
    (e) => {
      // getAttribute: the product form has an input named "id", which shadows the form's id property
      const formId = e.target.getAttribute('id');
      if (!formId) return;
      const confirm = document.querySelector(`[data-hs-confirm][form="${formId}"]`);
      if (confirm && !confirm.checked) {
        e.preventDefault();
        e.stopImmediatePropagation();
        confirm.setCustomValidity(confirm.dataset.message || '');
        confirm.closest('.hs-confirm')?.classList.add('hs-confirm--error');
        confirm.closest('.hs-confirm')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        confirm.reportValidity();
        return;
      }
      document.querySelectorAll(`.hs-gift__input[form="${formId}"]`).forEach((field) => {
        if (field.value.trim()) return;
        field.disabled = true; // excluded from Dawn's FormData, restored right after
        setTimeout(() => (field.disabled = false));
      });
    },
    true
  );
  document.querySelectorAll('[data-hs-confirm]').forEach((box) =>
    box.addEventListener('change', () => {
      box.setCustomValidity('');
      box.closest('.hs-confirm')?.classList.toggle('hs-confirm--error', !box.checked);
    })
  );

  /* ---------- Mobile sticky button ---------- */
  const sticky = $('[data-hs-sticky]');
  const submit = sticky && document.getElementById(`ProductSubmitButton-${sticky.dataset.section}`);
  if (sticky && submit && 'IntersectionObserver' in window) {
    // A transformed ancestor (Dawn's reveal-on-scroll animation) would pin a fixed bar to the column:
    // move it to <body>, keeping the section's color scheme
    const scheme = [...(sticky.closest('[class*="color-scheme-"]')?.classList || [])].find((c) => c.startsWith('color-scheme-'));
    if (scheme) sticky.classList.add(scheme);
    document.body.appendChild(sticky);
    // First rendered match, in the order the selectors are listed (querySelectorAll alone returns page order,
    // so an earlier review badge would beat the personalizer). Apps leave hidden and empty containers behind
    const visible = (list) => {
      for (const sel of (list || '').split(/,(?![^(]*\))/)) {
        try {
          const el = sel.trim() && [...document.querySelectorAll(sel)].find((e) => e.getBoundingClientRect().height);
          if (el) return el;
        } catch (e) {}
      }
      return null;
    };
    const appSticky = () => visible(sticky.dataset.appSticky);
    const button = $('button', sticky);
    // Products without a personalizer get "Add to cart" (theme setting: personalized tag). A personalizer that
    // shows up anyway wins, so required fields are never skipped because of a missing tag.
    const personalize = () => {
      if (sticky.dataset.personalized === 'true') return;
      sticky.dataset.personalized = 'true';
      $('span', button).textContent = sticky.dataset.labelPersonalize;
    };
    const target = () => visible(sticky.dataset.target) || $(`#variant-selects-${sticky.dataset.section}`) || submit;
    // Hidden while the personalizer's options are on screen (no bar over the fields); without a personalizer,
    // while the product form is. The whole form, not the button: some personalizers hide Add to cart
    const inView = new Set();
    const update = () => {
      const show = !inView.size && !appSticky();
      sticky.hidden = !show;
      document.body.classList.toggle('hs-has-sticky', show);
    };
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => (e.isIntersecting ? inView.add(e.target) : inView.delete(e.target)));
      update();
    });
    const form = submit.closest('product-form') || submit;
    io.observe(form);
    // Personalizer apps render late: once their container exists, watch it instead of the form
    const watchApp = () => {
      const app = visible(sticky.dataset.target);
      if (!app) return;
      io.unobserve(form);
      inView.delete(form);
      io.observe(app);
      update();
      personalize();
      window.removeEventListener('scroll', watchApp);
    };
    window.addEventListener('scroll', watchApp, { passive: true });
    watchApp();
    if (window.subscribe && typeof PUB_SUB_EVENTS !== 'undefined') {
      const priceEl = $('[data-hs-sticky-price]', sticky);
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (priceEl && data?.sectionId === sticky.dataset.section && data.variant)
          priceEl.textContent = formatMoney(data.variant.price, sticky.dataset.moneyFormat);
      });
    }
    button.addEventListener('click', () => {
      watchApp();
      if (sticky.dataset.personalized !== 'true' && !submit.disabled) return submit.click();
      const t = target();
      // A sticky header reappears while scrolling up, so leave room for its full height
      const header = $('.shopify-section-header-sticky');
      const offset = (header ? header.offsetHeight : 0) + 16;
      window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - offset, behavior: 'smooth' });
      const field = $('input:not([type=hidden]):not([type=radio]):not([type=checkbox]), textarea, select', t);
      if (field && field.type !== 'file' && !field.value) setTimeout(() => field.focus({ preventScroll: true }), 500);
    });
  }
})();
